import { render, staticRenderFns } from "./ProceedingsDetails.vue?vue&type=template&id=21d594b2&"
import script from "./ProceedingsDetails.vue?vue&type=script&lang=js&"
export * from "./ProceedingsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProceedingsDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports